export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_URL = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws`;
export const fileUrl = (id) => `${API}/files/${id}`;
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString("hu-HU", { hour: "2-digit", minute: "2-digit" }) : "");
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("hu-HU", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
